<template>
  <transition v-if="showChangeTarrifView" name="component-slide">
    <div class="slide-in change-tarrif">
      <div class="slide-in__wrap">
        <div
          class="slide-in__content change-tarrif__content"
          v-if="selectedTarrif != ''"
        >
          <div class="wrapper">
            <div class="slide-in__inner">
              <header class="slide-in__header">
                <h3 class="slide-in__headline">
                  {{ $t("depotfinder.results.change-tariff.headline") }}
                </h3>
                <button
                  class="close-btn icon-btn icon-btn--primary"
                  @click="closeSlideIn"
                >
                  <svg width="20" height="20">
                    <use xlink:href="#icon-close" />
                  </svg>
                </button>
              </header>
              <div class="tarrif-selections flex-grid grid-pad">
                <div
                  class="flex-grid__col c-4"
                  v-for="(tarif, index) in tarrifs"
                  :key="index"
                >
                  <div class="radio tarrif-selection">
                    <input
                      :id="index"
                      v-model="selectedTarrif"
                      type="radio"
                      name="radiogroup"
                      :value="index"
                    />
                    <label :for="index">
                      <h4 class="tarrif-selection__headline">
                        {{ tarif.name }}
                      </h4>
                      <span
                        class="tarrif-selection__text"
                        v-for="(text, index) in tarif.change_tarrif_text"
                        :key="index"
                        >{{ text }}</span
                      >
                      <span
                        :class="
                          `tarrif-selection__visual tarrif-selection__visual--${tarif.change_tarrif_visual}`
                        "
                      ></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="slide-in__content change-tarrif__selection"
          v-if="selectedTarrif != ''"
        >
          <div class="wrapper">
            <div class="slide-in__inner">
              <div class="flex-grid grid-pad flex-v-end">
                <div class="flex-grid__col c-4">
                  <UiHeadline
                    tag="h3"
                    theme=""
                    size="medium"
                    class="mb-0 change-tarrif__subline"
                  >
                    {{ $t("depotfinder.results.change-tariff.selection") }}
                  </UiHeadline>
                  <UiHeadline
                    tag="h4"
                    size="medium"
                    theme="primary"
                    class="mb-0 change-tarrif__selected-tarrif"
                  >
                    {{ tarrifs[selectedTarrif].name }}
                  </UiHeadline>
                </div>
                <div class="flex-grid__col c-4">
                  <ul class="depositmodel-conditions__list">
                    <li
                      v-for="(condition, index) in depositModelConditions(
                        tarrifs[selectedTarrif].conditions
                      )"
                      :key="index"
                      v-html="condition"
                    ></li>
                  </ul>
                </div>
                <div class="flex-grid__col c-4 flex flex-v-end flex-h-end">
                  <UiButton
                    theme="primary"
                    class="btn--small"
                    @click.native="applyTarrif()"
                  >
                    {{ $t("depotfinder.results.change-tariff.apply") }}
                  </UiButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import UiHeadline from "./../components/Ui/Headline.vue";
import UiButton from "./../components/Ui/Button/index.vue";
import { depositModelConditions } from "./../mixins/depositModelConditions.js";

export default {
  components: {
    UiButton,
    UiHeadline
  },
  mixins: [depositModelConditions],
  props: {
    activeDepositModel: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      tarrifs: {
        DepotExklusiv100: this.$t("depositmodels.DepotExklusiv100"),
        DepotExklusiv50: this.$t("depositmodels.DepotExklusiv50"),
        DepotExklusiv: this.$t("depositmodels.DepotExklusiv")
      },
      selectedTarrif: ""
    };
  },
  computed: {
    showChangeTarrifView() {
      return this.$store.getters.getChangeTarrifViewState;
    }
  },
  methods: {
    closeSlideIn() {
      this.$store.dispatch("updateView", {
        view: "changeTarrifView",
        payload: false
      });
      this.$store.dispatch("updateView", {
        view: "overlayBG",
        payload: false
      });
      this.selectedTarrif = this.$store.getters.getActiveDeposit;
    },
    applyTarrif() {
      // Set currently selected tarrif as active tarrif and close slideIn
      this.$store.dispatch("updateActiveDeposit", this.selectedTarrif);
      this.$store.dispatch("updateActiveDepositTab", this.selectedTarrif);
      this.closeSlideIn();
    },
    keyListeners: function(e) {
      // Listen to ESC key
      if (e.keyCode === 27) {
        if (this.$store.getters.getChangeTarrifViewState) {
          this.closeSlideIn();
        }
      }
    }
  },
  watch: {
    activeDepositModel(newValue) {
      this.selectedTarrif = newValue;
    }
  },
  mounted() {
    this.selectedTarrif = this.$store.getters.getActiveDeposit;
    document.addEventListener("keyup", this.keyListeners);
  },
  beforeDestroy() {
    document.removeEventListener("keyup", this.keyListeners);
  }
};
</script>
